import axios from "axios";

export const requestMovie = async (form: object) => {
  return await axios.post(`${process.env.REACT_APP_API_URL}/ezforms/submit`, {
    formName: "requestMovie",
    formData: form,
  });
};
